import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { Autocomplete, Pagination } from "@mui/material";
import moment from "moment-jalaali";
import { useEffect, useMemo, useState } from "react";
import { Collapse } from "react-collapse";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import fetchApi from "../../../utils/fetchApi";

const CollapsibleRow = ({ item, index, colSpan, page, pageSize }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <tr
        onClick={() => setIsExpanded(prev => !prev)}
        className="cursor-pointer border-b-myNeutralBorder [&>td]:text-center"
      >
        <th className="text-center">{index + 1 + (page - 1) * pageSize}</th>
        <td>
          <div className="flex justify-center items-center gap-2">
            <span className="text-myNeutralTitle tracking-tighter max-lg:whitespace-nowrap">
              {item?.f_name}
            </span>
          </div>
        </td>
        <td className="text-myNeutralTitle max-lg:whitespace-nowrap">
          {item?.l_name}
        </td>
        <td className="text-myNeutralTitle max-lg:whitespace-nowrap">
          {item?.provinceName}
        </td>
        <td className="text-myNeutralTitle">{item?.cityName}</td>
        <td className="text-myNeutralTitle">
          {item?.rewards_in_detail[2]?.reward +
            item?.rewards_in_detail[2]?.extraReward}
        </td>
        <td className="text-myNeutralTitle">
          {item?.rewards_in_detail[1]?.reward +
            item?.rewards_in_detail[1]?.extraReward}
        </td>
        <td className="text-myNeutralTitle">
          {item?.rewards_in_detail[3]?.reward +
            item?.rewards_in_detail[3]?.extraReward}
        </td>
        <td className="text-myNeutralTitle">
          {item?.rewards_in_detail[4]?.reward +
            item?.rewards_in_detail[4]?.extraReward}
        </td>
        <td className="text-myNeutralTitle">
          {item?.rewards_in_detail[7]?.reward +
            item?.rewards_in_detail[7]?.extraReward}
        </td>
        <th className="text-center">
          {item?.rewards_in_detail[8]?.reward +
            item?.rewards_in_detail[8]?.extraReward}
        </th>
        <th className="text-center">
          {item.rewards_in_detail
            .filter(item => [0, 5, 6].includes(item.sourceType))
            .reduce((acc, item) => acc + item.reward + item.extraReward, 0)}
        </th>
        <th className="text-center">{item?.rewards}</th>
        <th className="text-center aspect-square">
          <img
            className={`size-6 min-w-6`}
            src={`/img/dashboard/${
              item?.acc_level === "BRONZE"
                ? `bronzeMedal.png`
                : item?.acc_level === "SILVER"
                ? `silverMedal.png`
                : item?.acc_level === "GOLD"
                ? `goldMedal.svg`
                : `greenMedal.png`
            }`}
            alt="Rank"
          />
        </th>
      </tr>
      <tr>
        <td colSpan={colSpan} className="p-0 border-0">
          <Collapse isOpened={isExpanded}>
            <div className="bg-gray-100 p-4 rounded-b-lg mb-2 flex flex-col gap-2.5">
              <span className={`text-myNeutralTitle text-xs font-bold`}>
                اطلاعات بیشتر
              </span>
              <div className={`flex items-center gap-6`}>
                <div
                  className={`flex items-center gap-1 *:text-myNeutralTitle *:text-xs *:font-medium`}
                >
                  <span>شماره تماس: </span>
                  <span>{item?.mobile_number}</span>
                </div>
                {/* <div
                  className={`flex items-center gap-1 *:text-myNeutralTitle *:text-xs *:font-medium`}
                >
                  <span>کشور: </span>
                  <span>{item?.mobile_number}</span>
                </div> */}
                <div
                  className={`flex items-center gap-1 *:text-myNeutralTitle *:text-xs *:font-medium`}
                >
                  <span>تاریخ عضویت: </span>
                  <span>
                    {moment(item?.created_at).format("HH:mm - jYYYY/jMM/jDD")}
                  </span>
                </div>
                <div
                  className={`flex items-center gap-1 *:text-myNeutralTitle *:text-xs *:font-medium`}
                >
                  <span>تعداد عضوگیری در لیگ جاری: </span>
                  <span>{item?.number_of_referrals} نفر</span>
                </div>
              </div>
            </div>
          </Collapse>
        </td>
      </tr>
    </>
  );
};

export default function ElectedMembers() {
  // #region Table States

  const [eventsData, setEventsData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [firstInit, setFirstInit] = useState(false);

  // #endregion

  //#region Filter States and Variables

  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [provincesName, setProvincesName] = useState([]);
  const [citiesName, setCitiesName] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [rank, setRank] = useState();
  const [referrals, setReferrals] = useState({ from: "", to: "" });
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [sortList, setSortList] = useState([
    { key: "f_name", type: "" },
    { key: "l_name", type: "" },
    { key: "provinceName", type: "" },
    { key: "cityName", type: "" },
    { key: "biking", type: "" },
    { key: "walking", type: "" },
    { key: "event", type: "" },
    { key: "water", type: "" },
    { key: "gas", type: "" },
    { key: "electricity", type: "" },
    { key: "score", type: "" },
    { key: "encouragement", type: "" },
  ]);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [isMonthPickEnabled, setIsMonthPickEnabled] = useState(false);

  const ranks = [
    { name: "برنزی", value: "BRONZE" },
    { name: "نقره ای", value: "SILVER" },
    { name: "طلایی", value: "GOLD" },
    { name: "سبز", value: "GREEN" },
  ];

  const years = [1403, 1404];

  const months = [
    { key: "فروردین", value: 1 },
    { key: "اردیبهشت", value: 2 },
    { key: "خرداد", value: 3 },
    { key: "تیر", value: 4 },
    { key: "مرداد", value: 5 },
    { key: "شهریور", value: 6 },
    { key: "مهر", value: 7 },
    { key: "آبان", value: 8 },
    { key: "آذر", value: 9 },
    { key: "دی", value: 10 },
    { key: "بهمن", value: 11 },
    { key: "اسفند", value: 12 },
  ];

  // #endregion

  //#region Filter Logics and Function Declaration

  const handleProvinceChange = (event, newValue) => {
    setSelectedProvince(newValue);
  };

  const handleCityChange = (event, newValue) => {
    setSelectedCity(newValue);
  };

  const clearFilterValues = () => {
    setSearchValue("");
    setFromDate(null);
    setToDate(null);
    setSelectedProvince(null);
    setSelectedCity(null);
    setRank(-1);
    setReferrals({ from: "", to: "" });
  };

  // #endregion

  //#region Memoized Filter Payload

  const filterPayload = useMemo(() => {
    const activeSort = sortList.find(item => item.type !== "");

    return {
      term: searchValue || undefined,
      registerStartDate:
        fromDate &&
        moment(
          `${fromDate.year}-${fromDate.month}-${fromDate.day}`,
          "jYYYY-jM-jD"
        ).format("YYYY-MM-DD"),
      registerEndDate:
        toDate &&
        moment(
          `${toDate.year}-${toDate.month}-${toDate.day}`,
          "jYYYY-jM-jD"
        ).format("YYYY-MM-DD"),
      provinceId: selectedProvince?.id || undefined,
      cityId: selectedCity?.id || undefined,
      accRank: rank, // Ensure API doesn't receive null/undefined if unneeded
      numberOfReferralsStart: referrals?.from || undefined,
      numberOfReferralsEnd: referrals?.to || undefined,
      orderBy: activeSort
        ? JSON.stringify({ [activeSort.key]: activeSort.type })
        : undefined,
    };
  }, [
    searchValue,
    fromDate,
    toDate,
    selectedProvince,
    selectedCity,
    rank,
    referrals?.from,
    referrals?.to,
    sortList,
  ]);
  console.log(month);
  //#endregion

  const pageSize = "50";

  const fetchInitData = async filters => {
    setIsLoading(true);
    try {
      const data = await fetchApi(
        "GET",
        `${
          window?.location?.origin?.includes("localhost")
            ? `${process.env.REACT_APP_DEV_URL}`
            : `${process.env.REACT_APP_API_URL}`
        }/member/all/league`,
        {
          headers: {
            Authorization: `bearer ${localStorage.getItem("token")}`,
          },
          params: { page, pageSize: "50", ...(filters || {}) },
        }
      );
      setEventsData(data?.info);
      setTotalPages(data?.info?.metadata?.totalPages);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const fetchElectedData = async (filters, year, month) => {
    setIsLoading(true);
    try {
      const data = await fetchApi(
        "GET",
        `${
          window?.location?.origin?.includes("localhost")
            ? `${process.env.REACT_APP_DEV_URL}`
            : `${process.env.REACT_APP_API_URL}`
        }/member/reward-summary`,
        {
          headers: {
            Authorization: `bearer ${localStorage.getItem("token")}`,
          },
          params: {
            page,
            pageSize: "50",
            ...(filters || {}),
            year,
            month: +month,
          },
        }
      );
      setEventsData(data?.info);
      setTotalPages(data?.info?.metadata?.totalPages);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (firstInit) {
      fetchElectedData(appliedFilter, year, month);
    } else fetchInitData(appliedFilter);
  }, [page, appliedFilter, month]);

  // Calling For Provinces and Cities

  useEffect(() => {
    // Get All Provinces
    (async () => {
      try {
        const data = await fetchApi(
          "GET",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/location/provinces`,
          {
            headers: {
              Authorization: `bearer ${localStorage.getItem("token")}`,
            },
            params: {},
          }
        );
        //Change the format as can be used in MUI component
        const newFormat = data?.info?.map(option => ({
          id: option.id,
          label: option.name,
        }));
        setProvincesName(newFormat);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    // Get Corresponding Province Cities
    if (selectedProvince) {
      (async () => {
        try {
          const data = await fetchApi(
            "GET",
            `${
              window?.location?.origin?.includes("localhost")
                ? `${process.env.REACT_APP_DEV_URL}`
                : `${process.env.REACT_APP_API_URL}`
            }/location/province/cities`,
            {
              headers: {
                Authorization: `bearer ${localStorage.getItem("token")}`,
              },
              params: { provinceId: selectedProvince?.id },
            }
          );
          //Change the format as can be used in MUI component
          const newFormat = data?.info?.map(option => ({
            id: option.id,
            label: option.name,
          }));
          setCitiesName(newFormat);
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      })();
    }
  }, [selectedProvince]);

  const changeFilterStatus = key => {
    setSortList(prev => {
      const newSortList = prev.map(item => {
        if (item.key === key) {
          // Toggle sort type based on current value
          if (item.type === "") return { ...item, type: "DESC" };
          if (item.type === "DESC") return { ...item, type: "ASC" };
          return { ...item, type: "" }; // Reset to empty if currently ASC
        }
        // Reset other columns' sort
        return { ...item, type: "" };
      });

      // Trigger API call with new sort
      const activeSort = newSortList.find(item => item.type !== "");
      const newFilter = {
        ...appliedFilter,
        orderBy: activeSort
          ? JSON.stringify({ [activeSort.key]: activeSort.type })
          : undefined,
      };
      setAppliedFilter(newFilter);

      return newSortList;
    });
  };

  const SortIcon = ({ type }) => {
    if (!type) return null;
    return type === "DESC" ? "↓" : "↑";
  };

  useEffect(() => {
    //   Toggle flag for first api call (Current League)
    if (!firstInit) {
      setFirstInit(true);
    }
  }, []);

  return (
    <div
      className={`w-full flex flex-col justify-between h-[calc(100vh-192px)] overflow-y-auto scrollBar`}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className={`flex flex-col gap-11 scrollBar`}>
            <div className={`flex justify-between items-center scrollBar`}>
              <div className={`flex items-center gap-4 max-lg:hidden`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M14.1666 17.5H5.83329C2.49996 17.5 1.66663 16.6667 1.66663 13.3333V6.66667C1.66663 3.33333 2.49996 2.5 5.83329 2.5H14.1666C17.5 2.5 18.3333 3.33333 18.3333 6.66667V13.3333C18.3333 16.6667 17.5 17.5 14.1666 17.5Z"
                    stroke="#647177"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.6666 6.66663H15.8333"
                    stroke="#647177"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.5 10H15.8333"
                    stroke="#647177"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.1666 13.3334H15.8333"
                    stroke="#647177"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.08365 9.40827C7.91668 9.40827 8.59198 8.73296 8.59198 7.89993C8.59198 7.0669 7.91668 6.3916 7.08365 6.3916C6.25062 6.3916 5.57532 7.0669 5.57532 7.89993C5.57532 8.73296 6.25062 9.40827 7.08365 9.40827Z"
                    stroke="#647177"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.99996 13.6083C9.88329 12.4 8.92496 11.45 7.71663 11.3417C7.29996 11.3 6.87496 11.3 6.44996 11.3417C5.24163 11.4583 4.28329 12.4 4.16663 13.6083"
                    stroke="#647177"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={`text-myBlack414 text-lg font-semibold`}>
                  لیست شهروندان
                </span>
              </div>
              <div className={`flex items-center gap-4`}>
                <select
                  name="year"
                  value={year}
                  onChange={e => {
                    setYear(e.target.value);
                    if (e.target.value !== "") {
                      setIsMonthPickEnabled(true);
                    }
                  }}
                  className={`select select-bordered bg-white text-black focus:outline-none`}
                >
                  <option value="" disabled>
                    سال
                  </option>
                  {years?.map((itm, i) => {
                    return (
                      <option className={`text-black`} key={i} value={itm}>
                        {itm}
                      </option>
                    );
                  })}
                </select>
                <select
                  name="month"
                  disabled={!isMonthPickEnabled}
                  value={month}
                  onChange={e => {
                    setMonth(e.target.value);
                  }}
                  className={`select select-bordered bg-white text-black focus:outline-none disabled:opacity-60`}
                >
                  <option value="" disabled>
                    ماه
                  </option>
                  {months?.map((itm, i) => {
                    return (
                      <option
                        className={`text-black`}
                        key={i}
                        value={itm?.value}
                      >
                        {itm?.key}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={`pl-5 max-lg:hidden`}>
                <button
                  className={`btn shadow-sm !p-2.5`}
                  onClick={() => {
                    document.getElementById("filter_modal").showModal();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <path
                      d="M9.84202 19.3734C9.44744 19.3734 9.06109 19.2747 8.69939 19.0775C7.976 18.6747 7.54032 17.943 7.54032 17.121V12.7642C7.54032 12.3532 7.26905 11.7367 7.01422 11.4243L3.9398 8.16903C3.42192 7.65115 3.02734 6.76335 3.02734 6.0975V4.20682C3.02734 2.89156 4.02201 1.86401 5.28794 1.86401H16.1388C17.3883 1.86401 18.3994 2.87512 18.3994 4.12461V5.93309C18.3994 6.79623 17.8815 7.77445 17.3965 8.25946L13.8371 11.4079C13.4919 11.6956 13.2206 12.3285 13.2206 12.8382V16.373C13.2206 17.1046 12.7603 17.9513 12.1848 18.2965L11.0504 19.0281C10.6805 19.2583 10.2613 19.3734 9.84202 19.3734ZM5.28794 3.09707C4.71252 3.09707 4.2604 3.58207 4.2604 4.20682V6.0975C4.2604 6.40165 4.50701 6.99352 4.81938 7.30589L7.95134 10.6023C8.37058 11.1201 8.7816 11.9833 8.7816 12.756V17.1128C8.7816 17.6471 9.15151 17.9102 9.3077 17.9924C9.65295 18.1814 10.0722 18.1814 10.3928 17.9841L11.5354 17.2525C11.7656 17.1128 11.9958 16.6689 11.9958 16.373V12.8382C11.9958 11.9586 12.4232 10.9886 13.0397 10.4707L16.5581 7.35522C16.8376 7.07572 17.1746 6.40987 17.1746 5.92487V4.12461C17.1746 3.55741 16.7142 3.09707 16.147 3.09707H5.28794Z"
                      fill="#EA4335"
                    />
                    <path
                      d="M5.78109 9.59117C5.66601 9.59117 5.55914 9.55829 5.45228 9.50075C5.16457 9.3199 5.07414 8.93354 5.25499 8.64583L9.30763 2.15174C9.48848 1.86403 9.86661 1.77361 10.1543 1.95445C10.442 2.1353 10.5325 2.51344 10.3516 2.80115L6.29898 9.29524C6.18389 9.4843 5.9866 9.59117 5.78109 9.59117Z"
                      fill="#EA4335"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="overflow-x-auto scrollBar">
              <table className="table">
                {/* head */}
                <thead>
                  <tr className={`border-b-myNeutralBorder`}>
                    <th className={`text-myNeutralBody text-center`}>ردیف</th>
                    <th
                      className={`text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("f_name")}
                    >
                      نام
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "f_name")?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("l_name")}
                    >
                      نام خانوادگی
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "l_name")?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("provinceName")}
                    >
                      استان
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "provinceName")
                            ?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("cityName")}
                    >
                      شهر
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "cityName")?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("walking")}
                    >
                      پیاده‌روی
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "walking")?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("biking")}
                    >
                      دوچرخه‌سواری
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "biking")?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("event")}
                    >
                      رویداد
                      <SortIcon
                        type={sortList.find(item => item.key === "event")?.type}
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("water")}
                    >
                      مصرف آب
                      <SortIcon
                        type={sortList.find(item => item.key === "water")?.type}
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("gas")}
                    >
                      مصرف گاز
                      <SortIcon
                        type={sortList.find(item => item.key === "gas")?.type}
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("electricity")}
                    >
                      مصرف برق
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "electricity")
                            ?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("encouragement")}
                    >
                      تشویقی
                      <SortIcon
                        type={
                          sortList.find(item => item.key === "encouragement")
                            ?.type
                        }
                      />
                    </th>
                    <th
                      className={`text-myNeutralBody text-center cursor-pointer`}
                      onClick={() => changeFilterStatus("score")}
                    >
                      امتیاز لیگ جاری
                      <SortIcon
                        type={sortList.find(item => item.key === "score")?.type}
                      />
                    </th>
                    <th className={`text-myNeutralBody text-center`}>
                      رده
                      <SortIcon
                        type={sortList.find(item => item.key === "rank")?.type}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* row 1 */}
                  {eventsData?.data?.map((item, index) => (
                    <CollapsibleRow
                      key={index}
                      item={item}
                      index={index}
                      colSpan={15}
                      page={page}
                      pageSize={pageSize}
                    />
                  ))}
                </tbody>
                {/* foot */}
                {/* <tfoot>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Job</th>
                <th>Favorite Color</th>
                <th></th>
              </tr>
            </tfoot> */}
              </table>
            </div>
          </div>

          {/* Fixed Mobile Filter Icon */}
          <button
            className={`btn size-12 bg-myGreen34A hover:bg-myGreen34A rounded-full flex justify-center items-center !p-0 fixed left-5 bottom-28`}
            onClick={() => document.getElementById("filter_modal").showModal()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M8.99308 18.6191C8.59851 18.6191 8.21215 18.5205 7.85045 18.3232C7.12706 17.9204 6.69138 17.1888 6.69138 16.3667V12.0099C6.69138 11.5989 6.42011 10.9824 6.16528 10.67L3.09087 7.41476C2.57298 6.89688 2.17841 6.00908 2.17841 5.34323V3.45254C2.17841 2.13729 3.17307 1.10974 4.439 1.10974H15.2899C16.5394 1.10974 17.5505 2.12085 17.5505 3.37034V5.17882C17.5505 6.04196 17.0326 7.02018 16.5476 7.50518L12.9882 10.6536C12.6429 10.9413 12.3717 11.5743 12.3717 12.0839V15.6187C12.3717 16.3503 11.9113 17.197 11.3359 17.5422L10.2015 18.2739C9.83156 18.504 9.41232 18.6191 8.99308 18.6191ZM4.439 2.3428C3.86358 2.3428 3.41146 2.8278 3.41146 3.45254V5.34323C3.41146 5.64738 3.65807 6.23925 3.97044 6.55162L7.1024 9.84798C7.52164 10.3659 7.93266 11.229 7.93266 12.0017V16.3585C7.93266 16.8928 8.30257 17.1559 8.45876 17.2381C8.80402 17.4272 9.22325 17.4272 9.54385 17.2299L10.6865 16.4983C10.9166 16.3585 11.1468 15.9146 11.1468 15.6187V12.0839C11.1468 11.2043 11.5743 10.2343 12.1908 9.71646L15.7091 6.60094C15.9886 6.32145 16.3256 5.6556 16.3256 5.1706V3.37034C16.3256 2.80314 15.8653 2.3428 15.2981 2.3428H4.439Z"
                fill="white"
              />
              <path
                d="M4.93222 8.8369C4.81713 8.8369 4.71027 8.80402 4.6034 8.74647C4.31569 8.56562 4.22527 8.17927 4.40611 7.89156L8.45875 1.39747C8.6396 1.10976 9.01774 1.01933 9.30545 1.20018C9.59316 1.38103 9.68359 1.75917 9.50274 2.04688L5.4501 8.54096C5.33501 8.73003 5.13773 8.8369 4.93222 8.8369Z"
                fill="white"
              />
            </svg>
          </button>

          {/* Filter Modal */}
          <dialog id="filter_modal" className={`modal`}>
            <div className="modal-box bg-white rounded-xl shadow-2xl">
              <div className={`flex flex-col w-full`}>
                <div className={`flex justify-between items-center`}>
                  <div className={`flex items-center gap-2`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5.3999 2.1001H18.5999C19.6999 2.1001 20.5999 3.0001 20.5999 4.1001V6.3001C20.5999 7.1001 20.0999 8.1001 19.5999 8.6001L15.2999 12.4001C14.6999 12.9001 14.2999 13.9001 14.2999 14.7001V19.0001C14.2999 19.6001 13.8999 20.4001 13.3999 20.7001L11.9999 21.6001C10.6999 22.4001 8.8999 21.5001 8.8999 19.9001V14.6001C8.8999 13.9001 8.4999 13.0001 8.0999 12.5001L4.2999 8.5001C3.7999 8.0001 3.3999 7.1001 3.3999 6.5001V4.2001C3.3999 3.0001 4.2999 2.1001 5.3999 2.1001Z"
                        stroke="#232323"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.93 2.1001L6 10.0001"
                        stroke="#232323"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className={`text-myBlack2323 font-medium`}>
                      فیلتر
                    </span>
                  </div>
                  <button
                    className={`btn text-myRed font-medium border-none`}
                    onClick={clearFilterValues}
                  >
                    پاک‌کردن همه
                  </button>
                </div>

                {/* Search Input */}
                <div
                  className={`relative w-full h-11 flex items-center pb-4 border-b border-[#D0D5DD] my-4`}
                >
                  <input
                    type="text"
                    className={`input w-full text-myBlack2323 min-h-11 max-h-11 border-[#D0D5DD] focus:outline-none`}
                    placeholder="جستجو در جدول"
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                  />
                  <svg
                    className={`absolute left-6`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                      stroke="#667085"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div className={`flex flex-col w-full`}>
                  <div className="collapse collapse-arrow overflow-visible">
                    <input type="checkbox" />
                    <div className="collapse-title text-myBlack2323 font-medium overflow-visible *:overflow-visible">
                      بازه عضویت
                    </div>
                    <div className="collapse-content flex items-center overflow-visible justify-center gap-2 border-b border-[#D0D5DD]">
                      <DatePicker
                        inputClassName={`outline-none w-full h-[48px] rounded-lg !text-center !text-base !text-[#667085] font-bold`}
                        calendarClassName="!text-[8px]"
                        locale="fa"
                        calendarPopperPosition="bottom"
                        shouldHighlightWeekends
                        value={fromDate}
                        onChange={setFromDate}
                      />
                      <span className={`text-[#667085]`}>تا</span>
                      <DatePicker
                        inputClassName={`outline-none w-full h-[48px] rounded-lg !text-center !text-base !text-[#667085] font-bold`}
                        calendarClassName="!text-[8px]"
                        locale="fa"
                        calendarPopperPosition="bottom"
                        shouldHighlightWeekends
                        value={toDate}
                        onChange={setToDate}
                      />
                    </div>
                  </div>
                  <div className="collapse collapse-arrow overflow-visible">
                    <input type="checkbox" />
                    <div className="collapse-title text-myBlack2323 font-medium overflow-visible *:overflow-visible">
                      استان
                    </div>
                    <div className="collapse-content flex items-center overflow-visible justify-center gap-2 border-b border-[#D0D5DD]">
                      <Autocomplete
                        disablePortal
                        id="provinceNames"
                        options={provincesName}
                        onChange={handleProvinceChange}
                        sx={{ width: "100%" }}
                        renderInput={params => (
                          <div ref={params.InputProps.ref}>
                            <input
                              {...params.inputProps}
                              name="state"
                              type="text"
                              placeholder="خراسان رضوی"
                              autoComplete="off"
                              className={`input w-full bg-white rounded-lg border border-[#D0D5DD] text-black focus:outline-none`}
                            />
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="collapse collapse-arrow overflow-visible">
                    <input type="checkbox" />
                    <div className="collapse-title text-myBlack2323 font-medium overflow-visible *:overflow-visible">
                      شهر
                    </div>
                    <div className="collapse-content flex items-center overflow-visible justify-center gap-2 border-b border-[#D0D5DD]">
                      <Autocomplete
                        disablePortal
                        id="cityNames"
                        options={citiesName}
                        onChange={handleCityChange}
                        sx={{ width: "100%" }}
                        renderInput={params => (
                          <div ref={params.InputProps.ref}>
                            <input
                              {...params.inputProps}
                              name="city"
                              type="text"
                              placeholder="مشهد"
                              autoComplete="off"
                              className={`input w-full bg-white rounded-lg border border-[#D0D5DD] text-black focus:outline-none`}
                            />
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="collapse collapse-arrow overflow-visible">
                    <input type="checkbox" />
                    <div className="collapse-title text-myBlack2323 font-medium overflow-visible *:overflow-visible">
                      رده
                    </div>
                    <div className="collapse-content flex items-center overflow-visible justify-center gap-2 border-b border-[#D0D5DD]">
                      <select
                        className={`w-full select focus:outline-none border border-[#D0D5DD] *:max-w-fit`}
                        value={rank}
                        onChange={e => setRank(e.target.value)}
                        defaultValue={-1}
                      >
                        <option value={-1} disabled>
                          انتخاب کنید
                        </option>
                        {ranks?.map((itm, i) => (
                          <option value={itm?.value} key={i}>
                            {itm?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="collapse collapse-arrow overflow-visible">
                    <input type="checkbox" />
                    <div className="collapse-title text-myBlack2323 font-medium overflow-visible *:overflow-visible">
                      تعداد عضو گیری
                    </div>
                    <div className="collapse-content flex items-center overflow-visible justify-center gap-2 border-b border-[#D0D5DD]">
                      <input
                        type="tel"
                        className={`input w-full focus:outline-none border border-[#D0D5DD] text-center`}
                        value={referrals?.from}
                        onChange={e =>
                          setReferrals(prev => ({
                            ...prev,
                            from: e.target.value,
                          }))
                        }
                      />
                      <span className={`text-[#667085]`}>تا</span>
                      <input
                        type="tel"
                        className={`input w-full focus:outline-none border border-[#D0D5DD] text-center`}
                        value={referrals?.to}
                        onChange={e =>
                          setReferrals(prev => ({
                            ...prev,
                            to: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                  <form method="dialog">
                    <button
                      onClick={() => {
                        if (referrals?.from && referrals?.from?.length) {
                          if (referrals?.to && referrals?.to?.length) {
                            setAppliedFilter(filterPayload);
                          } else
                            toast?.info(
                              "لطفا بازه تعداد عضوگیری را مشخص کنید!"
                            );
                        } else setAppliedFilter(filterPayload);
                      }}
                      className={`w-full btn bg-myGreen34A text-white font-bold hover:bg-myGreen34A hover:scale-105 mt-10`}
                    >
                      اعمال
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <form method="dialog" className="modal-backdrop">
              <button>close</button>
            </form>
          </dialog>

          {/* Pagination */}
          <div className={`w-full flex justify-center items-center mt-5`}>
            {totalPages > 1 && (
              <Pagination
                count={totalPages}
                page={page}
                onChange={(e, value) => setPage(value)}
                dir="ltr"
                variant="outlined"
                size="large"
                hideNextButton={true}
                hidePrevButton={true}
                sx={{
                  button: {
                    borderColor: "#34A853",
                    "&:hover": {
                      backgroundColor: "#34A853",
                      opacity: "70%",
                      color: "white",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#34A853",
                      color: "white",
                      fontWeight: "bold",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#34A853",
                      color: "white",
                    },
                  },
                }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}
